var Resultats = function () {
    var grid = new Datatable();
    var lastCountry = 0;
    var displayComment = 0;

    var loadCountries = function (annee) {
        jQuery.ajax({
            url: basepath + '/' + locale + '/api/resultat/pays',
            method: 'GET',
            dataType: 'json',
            data: {
                annee: annee
            },
            success: function (response) {
                $('#search_results_pays').selectBox('options', response);
                $('#search_results_pays').selectBox('value', '');
            },
            error: function (jqXHR, textStatus, errorThrown) {
                try {
                    console.log(jqXHR.responseJSON.errors);
                } catch (e) {
                    try {
                        console.log(jqXHR.responseJSON.message);
                    } catch (e) {
                        console.log('Erreur inconnue');
                    }
                }
            },
            complete: function () {
                Tools.stopPageLoading();
            }
        });
    };

    var loadRegions = function (annee, pays) {
        pays = (typeof pays !== "undefined") ? pays : '';
        jQuery.ajax({
            url: basepath + '/' + locale + '/api/resultat/regions',
            method: 'GET',
            dataType: 'json',
            data: {
                annee: annee,
                pays: pays
            },
            success: function (response) {
                $('#search_results_region').selectBox('options', response);
                $('#search_results_region').selectBox('value', '');
            },
            error: function (jqXHR, textStatus, errorThrown) {
                try {
                    console.log(jqXHR.responseJSON.errors);
                } catch (e) {
                    try {
                        console.log(jqXHR.responseJSON.message);
                    } catch (e) {
                        console.log('Erreur inconnue');
                    }
                }
            },
            complete: function () {
                Tools.stopPageLoading();
            }
        });
    };

    var handleSearch = function () {
        var medals = {
            'vi': {
                'or': 'vi-or-{1}.png?v=1.1',
                'argent': 'vi-argent-{1}.png?v=1.1'
            },
            'vn': {
                'grand prix d\'excellence': 'vn-grand-prix-d-excellence-{1}.png?v=1.1',
                'prix d\'excellence': 'vn-prix-d-excellence-{1}.png?v=1.1',
                'prix des vinalies': 'vn-prix-des-vinalies-{1}.png?v=1.1',
                'vinalies or': 'vn-grand-prix-d-excellence-{1}.png?v=1.1',
                'vinalies argent': 'vn-prix-d-excellence-{1}.png?v=1.1'
            },
            'mdr': {
                'or': 'mdr-or-{1}.png?v=1.1',
                'argent': 'mdr-argent-{1}.png?v=1.1'
            },
            'olivalies': {
                'or': 'olivalies-or-{1}.png?v=1.1',
                'argent': 'olivalies-argent-{1}.png?v=1.1'
            },
            'cgvlr': {
                'or': 'cgvlr-or-{1}.png?v=1.1',
                'argent': 'cgvlr-argent-{1}.png?v=1.1'
            }
        };
        var tableOptions = {
            bStateSave: true,
            dom: "<'row'<'col-sm-7'pli><'col-md-4 col-sm-12'<'table-group-actions pull-right'>>r><'table-scrollable't><'row'<'col-md-7'pli><'col-md-4 col-sm-12'>>", // datatable layout
            columns: [
                {
                    data: 'special_award',
                    orderable: true,
                    render(data, type, full) {
                        let contest = grid.getDataTable().ajax.json().contest;
                        let output = '';
                        // Contest has special award and current item has not 0 value.
                        if (full.special_award) {
                            output += '<div class="special_award">';
                            if (contest.special_award_image) {
                                // Display image.
                                output += '<img title="' + contest.special_award_name +
                                        '" alt="' + contest.special_award_name +
                                        '" src="/' + contest.special_award_image + '" />';
                            }
                            // Display name.
                            output += '<h5 style="margin:0">' + contest.special_award_name + '</h5>';
                            if (full.special_award_category_name && full.special_award_category_name !== contest.special_award_name) {
                                output += '<div>' + full.special_award_category_name + '</div>';
                            }
                            output += '</div>';
                        }
                        return output;
                    }
                },
                {
                    data: "medaille",
                    orderable: true,
                    render(data, type, full) {

                        try {
                            if ((full.code_concours == 'mdr' && full.annee_concours <= 2014)
                                    || (full.code_concours == 'vn' && full.annee_concours <= 2015)) {
                                throw 'unable';
                            }
                            // The given name is the long one.
                            let dataLower = data.toLowerCase();
                            let filename = medals[full.code_concours][dataLower].replace('{1}', full.annee_concours);
                            return '<img width="50" height="50" title="' + dataLower + '" src="' + basepath + '/assets/pages/img/resultats/' + filename + '" /><br /><i class="medal-name">' + dataLower + '</i>';
                        } catch (e) {
                            return data;
                        }
                    }
                },
                {
                    data: "raison_sociale",
                    orderable: true
                },
                {
                    data: "designation",
                    orderable: true
                },
                {
                    data: "appellation",
                    orderable: true
                },
                {
                    data: "couleur",
                    orderable: true
                },
                {
                    data: "millesime",
                    orderable: true,
                    render(data, type, full, meta) {
                        if (data == 0) {
                            return '/';
                        } else {
                            return data;
                        }
                    }
                },
                {
                    data: "pays",
                    orderable: true
                },
                {
                    data: "region",
                    orderable: true
                },
                {
                    data: null,
                    orderable: false,
                    render(data, type, full, meta) {
                        var str = '';
                        // Get the translated strings used to create buttons
                        var diplomaButtonLabel = $('#translation-labels > #download-diploma-label').text();
                        var diplomaButtonTooltip = $('#translation-labels > #download-diploma-tooltip').text();
                        var diplomaNotCreatedButtonTooltip = $('#translation-labels > #download-diploma-not-created-tooltip').text();
                        var commentButtonLabel = $('#translation-labels > #comment-label').text();
                        var commentButtonTooltip = $('#translation-labels > #comment-tooltip').text();

                        // Create the download diploma button
                        str += '&nbsp;&nbsp;&nbsp;';
                        if (full.diplome == 1) {
                            str += '<a href="' + basepath + '/' + locale + '/resultats/diplome/' + full.origine + '/' + full.id_echantillon + '"';
                            str += 'class="tooltips" data-original-title="' + diplomaButtonTooltip + '"';
                            str += '>';
                            str += diplomaButtonLabel;
                            str += '</a>';
                        } else {
                            str += '<a disabled="disabled" ';
                            str += 'class="disabled tooltips" data-original-title="' + diplomaNotCreatedButtonTooltip + '"';
                            str += '>';
                            str += diplomaButtonLabel;
                            str += '</a>';
                        }

                        // Add space between the buttons
                        str += '&nbsp;&nbsp;&nbsp;';

                        // Create the see comment button
                        str += '<a href="' + basepath + '/' + locale + '/resultats/medaille/' + full.origine.substring(0, 1) + '-' + full.id_echantillon + '" ';
                        str += 'class="tooltips" data-original-title="' + commentButtonTooltip + '"';
                        str += '>';
                        str += commentButtonLabel;
                        str += '</a>';
                        str += '&nbsp;&nbsp;&nbsp;';

                        // Return the buttons
                        return str;
                    }
                }
            ],
            rowCallback(row, data, index) {
                row.className = "odd gradeX";
                return row;
            },
            initComplete() {
                // Init countries & regions
                var annee = $("input[name='search_results[annee_concours]']").val();
                loadCountries(annee);
                loadRegions(annee);
            },
            lengthMenu: [
                [10, 20, 50, 100],
                [10, 20, 50, 100] // change per page values here
            ],
            pageLength: 50, // default record count per page
            ajax: {
                url: basepath + "/" + locale + "/resultats/palmares-filter", // ajax source
            },
            language: {
                url: basepath + '/assets/model/plugins/i18n/French.json'
            },
            order: [
                [0, "desc"],
                [1, "asc"]
            ]
        };

        // Init
        grid.init({
            src: $("#datatable_results"),
            onDataLoad(grid) {
                // global tooltips
                $('.tooltips').tooltip({container: 'body'});
                $("select[name='datatable_results_length']").selectBox('destroy');
            },
            onSuccess(grid) {
                try {
                    displayComment = grid.getDataTable().ajax.json().displayComment;
                } catch (e) {
                }
            },
            onError(grid) {
                // execute some code on network or other general error
            },
            loadingMessage: 'Chargement...',
            dataTable: tableOptions
        });

        // handle filter cancel button click
        var table = grid.getTable();
        table.on('click', '.filter-cancel', function (e) {
            e.preventDefault();
            var annee = $("input[name='search_results[annee_concours]']").val();
            loadRegions(annee);
            grid.resetFilter();
        });

        // handle filter change
        $(".form-filter").on("change", function () {
            // Reset region if country change
            if ($('#search_results_pays').val() !== undefined && lastCountry != $('#search_results_pays').val()) {
                $('#search_results_region').selectBox('value', '');
            }
            grid.submitFilter();
        });

        $("#search_results_pays").on("change", function () {
            var pays = lastCountry = $(this).val();
            var annee = $("input[name='search_results[annee_concours]']").val();
            loadRegions(annee, pays);
        });
    };

    var stringify = function (data, level) {
        var string = '';
        for (var i in  data) {
            if (level == 0) {
                string += i
            } else {
                string += '[' + i + ']';
            }
            if (typeof data[i] == 'object') {
                string += stringify(data[i], level + 1);
            } else {
                string += '=' + data[i] + '&';
            }
        }

        return string;
    };

    window.dtt = grid;

    return {

        //main function to initiate the module
        init: function () {
            handleSearch();

            // global tooltips
            $('.tooltips').tooltip({container: 'body'});

            // Init page, fix selectBox issue
            $(function () {
                $('select.form-filter').each(function () {
                    $(this).selectBox('value', "");
                });
            });
        },
        displayAppellations: function (display) {
            grid.getDataTable().column(4).visible(!!display);
        },
        displayColours: function (display) {
            grid.getDataTable().column(5).visible(!!display);
        },
        displayMillesimes: function (display) {
            grid.getDataTable().column(6).visible(!!display);
        },
        displayCountries: function (display) {
            grid.getDataTable().column(7).visible(!!display);
        },
        displayRegions: function (display) {
            grid.getDataTable().column(8).visible(!!display);
        }
    };
}();
